/* LumaVibes universal product gallery: arrows + swipe + no horizontal page drag.
   Works on any custom product section using #lv-root .lv-main-wrap with a main
   <img> and .lv-thumb thumbnails. Prefix-agnostic. */
(function(){
  // Upgrade a Shopify CDN image URL to a higher render width so swapped images
  // stay crisp on retina screens (main image is generated at width=900 which
  // looks soft when shown large). Bumps the width param to 1600.
  function hi(url){
    if(!url)return url;
    if(/[?&]width=/.test(url))return url.replace(/([?&]width=)\d+/,'$11600');
    if(/[?&]/.test(url))return url+'&width=1600';
    return url+'?width=1600';
  }
  function init(){
    var root=document.getElementById('lv-root');
    if(!root)return;
    var wrap=root.querySelector('.lv-main-wrap');
    if(!wrap)return;
    if(wrap.getAttribute('data-lvgal')==='1')return; // idempotent
    wrap.setAttribute('data-lvgal','1');
    var mainImg=wrap.querySelector('img');
    if(!mainImg)return;

    var thumbs=Array.prototype.slice.call(root.querySelectorAll('.lv-thumb'));
    function imgList(){
      var list=[];
      thumbs.forEach(function(t){
        var oc=t.getAttribute('onclick')||'';
        var m=oc.match(/(https?:[^'\"]+)/);
        if(m){list.push(m[1]);}
        else{var im=t.querySelector('img');if(im)list.push(im.src);}
      });
      if(!list.length&&mainImg.src)list.push(mainImg.src);
      return list;
    }
    var imgs=imgList();
    if(imgs.length<2)return;

    // Preload hi-res versions up front so navigation is instant & crisp.
    imgs.forEach(function(u){var p=new Image();p.src=hi(u);if(p.decode){p.decode().catch(function(){});}});

    function currentIndex(){
      var src=(mainImg.getAttribute('src')||'').split('?')[0];
      for(var k=0;k<imgs.length;k++){
        if(imgs[k].split('?')[0]===src)return k;
      }
      return 0;
    }

    var busy=false;
    function show(i){
      if(busy)return;
      if(i<0)i=imgs.length-1;
      if(i>=imgs.length)i=0;
      var url=hi(imgs[i]);
      thumbs.forEach(function(t){t.classList.remove('active');});
      if(thumbs[i])thumbs[i].classList.add('active');
      var loader=new Image();
      loader.src=url;
      function swap(){mainImg.src=url;}
      if(loader.decode){
        busy=true;
        loader.decode().then(function(){busy=false;swap();}).catch(function(){busy=false;swap();});
      }else if(loader.complete&&loader.naturalWidth){
        swap();
      }else{
        loader.onload=swap;loader.onerror=swap;
      }
    }

    if(!wrap.querySelector('.lv-nav')){
      var prev=document.createElement('div');
      prev.className='lv-nav lv-nav-prev';prev.textContent='\u2039';
      prev.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();show(currentIndex()-1);});
      var next=document.createElement('div');
      next.className='lv-nav lv-nav-next';next.textContent='\u203a';
      next.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();show(currentIndex()+1);});
      wrap.appendChild(prev);wrap.appendChild(next);
    }

    var x0=null,y0=null;
    wrap.addEventListener('touchstart',function(e){x0=e.changedTouches[0].clientX;y0=e.changedTouches[0].clientY;},{passive:true});
    wrap.addEventListener('touchend',function(e){
      if(x0===null)return;
      var dx=e.changedTouches[0].clientX-x0;
      var dy=e.changedTouches[0].clientY-y0;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){
        if(dx<0)show(currentIndex()+1);else show(currentIndex()-1);
      }
      x0=null;y0=null;
    },{passive:true});
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{init();}
  document.addEventListener('shopify:section:load',init);
})();
